export default __webpack_public_path__ + "021f2b099861958280211dfb350b6303.png";